import { gql } from "graphql-tag";

export const variableFragments = gql`
  #
  # ──────────────────────────
  #  VARIABLE FRAGMENTS
  # ──────────────────────────
  #
  # Don't need variable id in entry fields for now as we only inherit one level (from product) currently
  fragment VariableEntryFields on variable_Entry {
    plainText
    inheritIfEmpty
    variableToInherit {
      # only set on scoped variables
      ... on variable_Entry {
        id
      }
    }
    showForTheFollowingProducts {
      ... on product_Entry {
        id
      }
    }
    showForTheFollowingProductFeatures {
      ... on productFeatures_Category {
        id
      }
    }
    showForTheFollowingProductCategories {
      ... on productCategories_Category {
        id
      }
    }
    variableConditions {
      ... on variable_Entry {
        id
        plainText
        inheritIfEmpty
        showForTheFollowingProducts {
          ... on product_Entry {
            id
          }
        }
        showForTheFollowingProductFeatures {
          ... on productFeatures_Category {
            id
          }
        }
        showForTheFollowingProductCategories {
          ... on productCategories_Category {
            id
          }
        }
      }
    }
  }
`;
export default variableFragments;